import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { Comment } from '../../../models/Comment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as CommentSelectors from '../../../state/comment/comment.selector';
import * as CommentActions from '../../../state/comment/comment.actions';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-order-comments-card',
  imports: [
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './order-comments-card.component.html',
  styleUrl: './order-comments-card.component.css',
})
export class OrderCommentsCardComponent implements OnInit, OnChanges {
  @Input() orderId: number | null = null;
  @Input() orderReflexNo: string | null = null;
  comments$!: Observable<Comment[]>;
  loading$!: Observable<boolean>;
  // For comment input and actions
  newCommentText: string = '';
  editingId: number | null = null;
  editText: string = '';

  constructor(private store: Store) {
    this.loading$ = this.store.select(CommentSelectors.selectCommentsLoading);
  }

  ngOnInit(): void {
    this.configureSelection();
    this.loadIfPossible();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderId'] || changes['orderReflexNo']) {
      this.configureSelection();
      this.loadIfPossible();
    }
  }

  private configureSelection() {
    const key = this.orderReflexNo ?? (this.orderId ? String(this.orderId) : null);
    if (key) this.comments$ = this.store.select(CommentSelectors.selectCommentsForReflex(key));
  }

  private loadIfPossible() {
    const key = this.orderReflexNo ?? (this.orderId ? String(this.orderId) : null);
    if (key) this.store.dispatch(CommentActions.loadCommentsByReflex({ reflexNo: key }));
  }

  addComment(commentText?: string) {
    const text = typeof commentText === 'string' ? commentText : this.newCommentText;
    const key = this.orderReflexNo ?? (this.orderId ? String(this.orderId) : null);
    if (!text || !text.trim() || !key) return;
    const clientId = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
    this.store.dispatch(CommentActions.addComment({ reflexNo: key, commentText: text.trim(), clientId }));
    this.newCommentText = '';
  }

  startEdit(comment: Comment) {
    if (!comment.id) return;
    this.editingId = comment.id;
    this.editText = comment.commentText ?? '';
  }

  cancelEdit() {
    this.editingId = null;
    this.editText = '';
  }

  saveEdit(comment: Comment) {
    if (!this.editingId || !comment.id) return;
    const updatedText = this.editText.trim();
    if (!updatedText) return;
    const changed: Comment = { ...comment, commentText: updatedText };
    this.store.dispatch(CommentActions.updateComment({ comment: changed }));
    this.cancelEdit();
  }

  deleteComment(comment: Comment) {
    const key = this.orderReflexNo ?? (this.orderId ? String(this.orderId) : null);
    if (!comment.id || !key) return;
    if (!confirm('Kommentar wirklich löschen?')) return;
    this.store.dispatch(CommentActions.deleteComment({ reflexNo: key, id: comment.id }));
  }
}
